import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import {useSelector} from "react-redux";
import {apiUrlSelector} from "../redux/selectors";

export const useCreateMachine = ({ onError, onSuccess}) => {
    
    const apiUrl = useSelector(apiUrlSelector);
    const queryClient = useQueryClient();

    return useMutation(values => {
        
            if ( parseInt(values.id) > 0 ) {
                return axios.patch(`${apiUrl}machinery/${values.id}`, values).then(res => res.data);
            } else {
                return axios.post(`${apiUrl}machinery`, values).then(res => res.data)
            }
        },
        {
            onSuccess: () => {
                onSuccess();
                queryClient.invalidateQueries(["machinery", apiUrl]);
            }, onError: onError
        }
    );
};

export default useCreateMachine;